module.exports = __webpack_public_path__ + "static/media/c#.abe71a3a.png";